import {
  ISwitchAgentAccordionGroup,
  ISwitchAgentAccordionItem,
} from '@/pages/aigc/components/SwitchAgentAccordion';

import { buildAgentFoldAccordion } from './buildAgentFoldAccordion';

export interface IResolveAgentAccordionParams {
  accordionSource: ISwitchAgentAccordionItem[];
  formatMessage: (descriptor: { id: string; }) => string;
  streamingState?: string;
  messageId?: string;
}

/** agent 折叠数据出口：预构建 content，外层组件无感 */
export const resolveAgentAccordionData = (
  params: IResolveAgentAccordionParams,
): {
  accordionData: ISwitchAgentAccordionGroup[];
  trailingInlineItems: ISwitchAgentAccordionItem[];
} => ({
  accordionData: buildAgentFoldAccordion(params),
  trailingInlineItems: [],
});
